//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zh_TW from 'ant-design-vue/lib/locale-provider/zh_TW';
import moment from 'moment';
import 'moment/locale/zh-tw';
moment.locale('zh-cn');

export default ({
	data() {
		return {
			zh_TW
		}
	},
	computed: {
		// Sets components name based on current route's specified layout, defaults to
		// <layout-default></layout-default> component.
		layout() {
			return "layout-" + (this.$route.meta.layout || "default").toLowerCase();
		}
	},
})

